import { Box, Divider, FormControl, Grid, InputLabel, MenuItem, Pagination, Select, SelectChangeEvent, Tab, Tabs, Typography } from '@mui/material';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { useCallback, useEffect, useMemo, useState } from 'react';
import ProfileSectionHeader from 'components/common/ProfileSectionHeader/ProfileSectionHeader';
import useGlobalStyles from 'styles/globalStyles';
import { colors } from 'styles/colors';
import { useGetReports } from 'hooks/useCases';
import { useAuth } from 'context/AuthContext';
import ExportedItem from '../ExportedItem/ExportedItem';
import ExportedItemSkeleton from '../ExportedItemSkeleton/ExportedItemSkeleton';
import DashboardIcon from 'icons/DashboardIcon';
import CustomFormSelect from 'components/inputs/CustomFormSelect/CustomFormSelect';
import { FormProvider, useForm } from 'react-hook-form';
import { enumToLabelValueList } from 'common/utils';
import CustomText from 'components/common/CustomText/CustomText';
import DashboardInvitations from './DashboardInvitations';
import JoinedDashboards from './JoinedDashboards';

enum searchEnum {
  INVITATIONS = 'invitations',
  JOINED_DASHBOARDS = 'joined_dashboards',
}

interface Props {
  defaultView?: string;
}

export default function ProfileDashboard({ defaultView }: Props) {
  const { user } = useAuth();
  const globalStyles = useGlobalStyles();

  const methods = useForm({
    defaultValues: {
      view: defaultView ?? 'invitations',
    },
  });

  const {
    watch,
  } = methods;

  const view = watch('view');

  const viewOptions = enumToLabelValueList(searchEnum);


  const renderContent = useCallback(() => {
    if (view == 'invitations') {
      return (
        <Box>
          <DashboardInvitations />
        </Box>
      )
    } else if (view == 'joined_dashboards') {
      return (
        <Box>
          <JoinedDashboards />
        </Box>
      )
    }
  }, [view]);

  return (
    <Box
      className={globalStyles.sectionContainer}
      sx={{
        minHeight: '80vh',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box sx={{ flexGrow: 1 }}>
        <Box px={2}>
          <ProfileSectionHeader
            title="Dashboard"
            icon={
              <DashboardIcon
                color={colors.primary}

              />
            }
            buttons={[]}
          />
        </Box>

        <Divider />

        <Box p={2}>
          <FormProvider {...methods}>
            <Box sx={{ width: 250 }}>
              <CustomFormSelect
                name='view'
                options={viewOptions}
                floatingLabel='View'
              />
            </Box>
          </FormProvider>
        </Box>

        {renderContent()}
      </Box>

    </Box>
  );
}
